<template>
    <div class="container mt-4">
        <h2>Clients</h2>

        <div v-if="loading" class="text-center mt-3">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <ClientList v-for="distributor in distributors" :key="distributor.id as string" :distributor="distributor" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ClientList from "./parts/ClientList.vue";
import distributorService from "@/services/distributor.service";
import { Distributor } from "@/models/distributor.model";

export default defineComponent({
    components: { ClientList },
    data() {
        return {
            distributors: ref<Distributor[]>([]),
            loading: ref(false),
        };
    },
    methods: {
        async fetchDistributors() {
            this.loading = true;
            try {
                const response = await distributorService.getDistributors();
                this.distributors = [...response];
            } catch (error) {
                console.error("Error fetching distributors:", error);
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.fetchDistributors();
    },
});
</script>